import PropTypes from 'prop-types';
import { get } from 'react-hook-form';

function FormErrors({ errors = {}, name = '' }) {
  const e = get(errors, name);

  return errors && e && e.message ? (
    <p className="mt-2 text-red-500 text-sm" id={`${name}-error`}>
      {e.message}
    </p>
  ) : null;
}

FormErrors.propTypes = {
  errors: PropTypes.object,
  name: PropTypes.string,
};

export default FormErrors;
